import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectCurrentPendingOrders,
  selectCurrentUserId,
} from "../../features/auth/authSlice";
import {
  useGetOrdersByStatusBuyerMutation,
  useGetOrdersByStatusSellerMutation,
} from "../../features/auth/authApiSlice";
import BuyerOrderDetail from "./BuyerOrderDetail";
import "../../styles/buyerProfile.css";

function BuyerOrderDetailsPage({ orderStatus }) {
  const [pendingOrders, setPendingOrders] = useState([]);
  const [preparingOrders, setPreparingOrders] = useState([]);
  const [onthewayOrders, setOnthewayOrders] = useState([]);
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [fetchedOrders, setFetchedOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const pendingOrderIdsList = useSelector(selectCurrentPendingOrders);
  const buyerId = useSelector(selectCurrentUserId);
  const [getOrdersByStatusAndBuyer, { isSellerLoading }] =
    useGetOrdersByStatusBuyerMutation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        if (orderStatus === "pending") {
          const result = await getOrdersByStatusAndBuyer({
            orderStatus: "pending",
            buyerId: buyerId,
          }).unwrap();

          setFetchedOrders(result);
        } else if (orderStatus === "preparing") {
          const result = await getOrdersByStatusAndBuyer({
            orderStatus: "preparing",
            buyerId: buyerId,
          }).unwrap();

          setFetchedOrders(result);
        } else if (orderStatus === "ontheway") {
          const result = await getOrdersByStatusAndBuyer({
            orderStatus: "ontheway",
            buyerId: buyerId,
          }).unwrap();

          setFetchedOrders(result);
        } else if (orderStatus === "delivered") {
          const result = await getOrdersByStatusAndBuyer({
            orderStatus: "delivered",
            buyerId: buyerId,
          }).unwrap();

          setFetchedOrders(result);
        } else if (orderStatus === "cancelled") {
          const result = await getOrdersByStatusAndBuyer({
            orderStatus: "cancelled",
            buyerId: buyerId,
          }).unwrap();

          setFetchedOrders(result);
        }

        setIsLoading(false);
         // Update state with the fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Invoke the fetchData function when the component mounts or when 'Id' changes
  }, [buyerId]); // Include 'Id' as a dependency to refetch data when 'Id' changes

  return (
    <>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div
          className={` text-gray-800 px-2 md:px-6 py-4  bg-gray-100 w-full`}
          style={{ overflowY: "auto", height: "calc(100vh - 56px)" }}
        >
          <div className="w-full bg-white h-16 flex items-center px-2 rounded-md  text-lg text-opacity-70">
            {orderStatus.charAt(0).toUpperCase() + orderStatus.slice(1)} Orders
          </div>
          {fetchedOrders.map((order, index) => (
            <BuyerOrderDetail
              index={index}
              order={order}
              orderStatus={orderStatus}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default BuyerOrderDetailsPage;
